const PictProvider = require('pict-provider');

const DEFAULT_PROVIDER_CONFIGURATION =
{
	ProviderIdentifier: 'FormInitialBundle-Provider',

	AutoInitialize: true,
	AutoInitializeOrdinal: 0,
};

class FormInitialBundleProvider extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, Object.assign({}, DEFAULT_PROVIDER_CONFIGURATION, pOptions), pServiceHash);

		/** @type {import('headlight-configurable-application').Pict} */
		this.pict;
	}

	/**
	 * Whether a bundle has a ProjectDataset step.
	 *
	 * @param {Array<Record<string, any>>} pBundle - The entity bundle description.
	 * @return {boolean}
	 */
	hasProjectDatasetStep(pBundle)
	{
		return Array.isArray(pBundle) && pBundle.some((pStep) => pStep && (pStep.Type === 'ProjectDataset'));
	}

	/**
	 * Remove the output of every ProjectDataset step in a bundle, so the next gather builds it fresh.
	 * pict's projectDataset only creates its output when missing and otherwise appends to it or updates it in place.
	 *
	 * @param {Array<Record<string, any>>} pBundle - The entity bundle description.
	 * @return {Array<{ Address: string, Value: any }>} The removed outputs, for restoreProjectDatasetOutputs.
	 */
	clearProjectDatasetOutputs(pBundle)
	{
		const tmpCleared = [];
		if (!Array.isArray(pBundle))
		{
			return tmpCleared;
		}
		const tmpAddressSpace = this.pict.EntityProvider.prepareState({});
		for (const tmpStep of pBundle)
		{
			if (tmpStep && (tmpStep.Type === 'ProjectDataset') && (typeof tmpStep.OutputRecordsetAddress === 'string') && (tmpStep.OutputRecordsetAddress.length > 0))
			{
				tmpCleared.push({ Address: tmpStep.OutputRecordsetAddress, Value: this.pict.manifest.getValueByHash(tmpAddressSpace, tmpStep.OutputRecordsetAddress) });
				this.pict.manifest.deleteValueByHash(tmpAddressSpace, tmpStep.OutputRecordsetAddress);
			}
		}
		return tmpCleared;
	}

	/**
	 * Put back the outputs clearProjectDatasetOutputs removed.
	 *
	 * @param {Array<{ Address: string, Value: any }>} pCleared - The return value of clearProjectDatasetOutputs.
	 * @return {void}
	 */
	restoreProjectDatasetOutputs(pCleared)
	{
		const tmpAddressSpace = this.pict.EntityProvider.prepareState({});
		for (const tmpEntry of pCleared)
		{
			if (typeof tmpEntry.Value !== 'undefined')
			{
				this.pict.manifest.setValueByHash(tmpAddressSpace, tmpEntry.Address, tmpEntry.Value);
			}
		}
	}

	/**
	 * Rebuild every pick list a form manifest declares.
	 *
	 * @param {Record<string, any>} pManifest - The form manifest.
	 * @return {void}
	 */
	rebuildPickLists(pManifest)
	{
		for (const tmpPickList of (pManifest && pManifest.PickLists) || [])
		{
			this.pict.providers.DynamicMetaLists.rebuildListByHash(tmpPickList.Hash);
		}
	}

	/**
	 * Gather a form manifest's InitialBundle, replacing any ProjectDataset output from an earlier gather, then
	 * rebuild the manifest's pick lists. When the gather fails, the earlier ProjectDataset outputs are put back and
	 * the lists are still rebuilt.
	 *
	 * @param {Record<string, any>} pManifest - The form manifest.
	 * @param {Function} fCallback - Called with the gather error, if any.
	 * @return {void}
	 */
	gatherInitialBundle(pManifest, fCallback)
	{
		const tmpBundle = pManifest ? pManifest.InitialBundle : undefined;
		const tmpCleared = this.clearProjectDatasetOutputs(tmpBundle);
		this.pict.EntityProvider.gatherDataFromServer(tmpBundle, (pError) =>
		{
			if (pError)
			{
				this.restoreProjectDatasetOutputs(tmpCleared);
			}
			this.rebuildPickLists(pManifest);
			return fCallback(pError);
		});
	}
}

module.exports = FormInitialBundleProvider;
module.exports.default_configuration = DEFAULT_PROVIDER_CONFIGURATION;
